import React from "react";
import styled from "styled-components";
import { withTopNineVideo, VideoSteps } from "../../core/withVideo";
import Modal from "../common/Modal";
import PreviewStep from "./PreviewStep";
import ChooseTemplateStep from "./ChooseTemplateStep";
import RenderingStep from "./RenderingStep";
import CompletedStep from "./CompletedStep";

const TopNineVideo = props => {
  const {
    videoStep,
    getCurrentComposition,
    onCreateVideoOrder,
    createVideoOrderLoading,
    createVideoOrderError,
    onCancelRendering,
    videoUrl,
  } = props;
  let content = null;
  switch (videoStep) {
    case VideoSteps.CHOOSE_TEMPLATE:
      content = (
        <ChooseTemplateStep
          videoTemplates={props.videoTemplates}
          videoTemplatesLoading={props.videoTemplatesLoading}
          videoTemplatesError={props.videoTemplatesError}
          currentVideoTemplate={props.currentVideoTemplate}
          onChooseTemplate={props.onChooseTemplate}
          onVideoTemplateSlideTo={props.onVideoTemplateSlideTo}
          activeTemplateIndex={props.activeTemplateIndex}
          open={props.open}
        />
      );
      break;
    case VideoSteps.PREVIEW:
      content = (
        <PreviewStep
          getCurrentComposition={getCurrentComposition}
          onCreateVideoOrder={onCreateVideoOrder}
          createVideoOrderLoading={createVideoOrderLoading}
          createVideoOrderError={createVideoOrderError}
          videoPrice={props.videoPrice}
          {...props}
        />
      );
      break;
    case VideoSteps.RENDERING:
      content = (
        <RenderingStep getCurrentComposition={getCurrentComposition} onCancelRendering={onCancelRendering} />
      );
      break;
    case VideoSteps.DONE:
      content = (
        <CompletedStep
          videoUrl={videoUrl}
          onDownload={() => {
            window.open(videoUrl, "_blank");
            // onRequestClose();
          }}
        />
      );
      break;
  }

  return <Container>{content}</Container>;
};

const CustomModal = styled(Modal)`
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  @media (min-width: 600px) {
    max-width: 760px;
    max-height: 650px;
  }
`;

const Container = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  padding: 20px 0px 0px;
`;

const VideoModal = props => (
  <CustomModal
    {...props}
    onRequestClose={() => {
      props.onRequestClose();
      if (window.gtag) window.gtag("event", "video_modal_close");
      props.setVideoStep(VideoSteps.CHOOSE_TEMPLATE);
    }}
    showCloseButton={props.showCloseAction}
    darkCloseButton={true}
    withoutRadius={true}
  >
    {props.showBackAction && (
      <BackButton onClick={props.handlePrevStep}>
        <BackIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-arrow-left"
          >
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
        </BackIcon>
      </BackButton>
    )}
    <TopNineVideo {...props} />
  </CustomModal>
);

const BackButton = styled.div`
  cursor: pointer;
  position: absolute;
  top: 37px;
  left: 35px;
  width: 50px;
  height: 50px;
  @media (max-width: 640px) {
    right: 23px;
  }
`;

const BackIcon = styled.div``;

export default withTopNineVideo(VideoModal);
